import { createAction, props } from "@ngrx/store";

export const fetchDownlines = createAction(
  "[Downline] Fetch",
  props<{ page, filterOptions }>()
);

export const fetchDownlinesSuccess = createAction(
  "[Downline] Fetch Success",
  props<{ downlines }>()
);

export const fetchDownlinesFailure = createAction(
  "[Downline] Fetch Faild",
  props<{ error }>()
);

export const getDownline = createAction(
  "[Downline] Get",
  props<{ downlineID }>()
);

export const getDownlineSuccess = createAction(
  "[Downline] Get Success",
  props<{ downline }>()
);

export const getDownlineFailure = createAction(
  "[Downline] Get Faild",
  props<{ error }>()
);

export const addInvitation = createAction(
  "[Downline] Add Invitation",
  props<{ invitation }>()
);

export const addInvitationSuccess = createAction(
  "[Downline] Add Invitation Success",
  props<{ invitation }>()
);

export const addInvitationFailure = createAction(
  "[Downline] Add Invitation Failure",
  props<{ error }>()
);
